// globalFetchProbe.ts - 全域抓包：看是不是請求真的「掛住」
(() => {
  const orig = window.fetch;
  let inflight = 0;
  window.fetch = async (...args: any[]) => {
    const url = String(args[0]);
    const t0 = performance.now();
    inflight++;
    console.log('🌐[FETCH+]', { url, inflight });
    try {
      const res = await orig(...args);
      const t1 = Math.round(performance.now() - t0);
      console.log('🌐[FETCH✔]', { url, status: res.status, ms: t1, inflight: inflight - 1 });
      return res;
    } catch (e) {
      const t1 = Math.round(performance.now() - t0);
      console.warn('🌐[FETCH✖]', { url, ms: t1, inflight: inflight - 1, err: (e as any)?.name });
      throw e;
    } finally {
      inflight--;
    }
  };
})();
